'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import UIList from 'UIComponents/list/UIList';
import { BookIcon, LessonIcon, WebsiteIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { useLeadGenContext } from '../../../../context/LeadGenContext';
import { getEventSelectorId } from '../../../../utils/analytics';
import { getFormattedUrl } from '../../../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const I18N_PATH = 'appMarketplace.detail.overview.sidebar.resources';
const Resources = ({
  casesUrl,
  onTrackInteraction,
  setupUrl,
  companyUrl
}) => {
  const {
    runLeadGen
  } = useLeadGenContext();
  const trackInteraction = useCallback(action => onTrackInteraction(action, {
    section: 'resources'
  }), [onTrackInteraction]);
  return /*#__PURE__*/_jsxs(UIList, {
    children: [/*#__PURE__*/_jsx(UILink, {
      "data-hs-analytics-id": getEventSelectorId('SIDEBAR-SETUP-GUIDE'),
      external: true,
      href: getFormattedUrl(setupUrl),
      iconProps: {
        className: 'hidden'
      },
      onClick: () => trackInteraction('click setup guide link'),
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "200",
        children: [/*#__PURE__*/_jsx(LessonIcon, {
          color: "do-not-use-eerie"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${I18N_PATH}.setupGuideLinkText`
        })]
      })
    }), companyUrl && /*#__PURE__*/_jsx(UILink, {
      "data-hs-analytics-id": getEventSelectorId('SIDEBAR-COMPANY'),
      external: true,
      href: getFormattedUrl(companyUrl),
      iconProps: {
        className: 'hidden'
      },
      onClick: () => {
        runLeadGen();
        trackInteraction('click company website link');
      },
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "200",
        children: [/*#__PURE__*/_jsx(WebsiteIcon, {
          color: "do-not-use-eerie"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${I18N_PATH}.companyWebsiteLinkText`
        })]
      })
    }), casesUrl && /*#__PURE__*/_jsx(UILink, {
      external: true,
      href: getFormattedUrl(casesUrl),
      iconProps: {
        className: 'hidden'
      },
      onClick: () => trackInteraction('click case study link'),
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "200",
        children: [/*#__PURE__*/_jsx(BookIcon, {
          color: "do-not-use-eerie"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${I18N_PATH}.caseStudyLinkText`
        })]
      })
    })]
  });
};
Resources.propTypes = {
  casesUrl: PropTypes.string,
  onTrackInteraction: PropTypes.func.isRequired,
  setupUrl: PropTypes.string.isRequired,
  companyUrl: PropTypes.string
};
export default Resources;